import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import classificationReducer from './slices/classificationSlice'
import { authApi, classificationApi } from './api'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    classification: classificationReducer,
    [classificationApi.reducerPath]: classificationApi.reducer,
    [authApi.reducerPath]: authApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      classificationApi.middleware,
      authApi.middleware
    ])
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
